import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { API_URL } from './api-config.service';
import { AlertService } from '../alert/alert.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { ApiGatewayService, APIGatewayInitRequest } from '../api-gateway/api-gateway.service';


@Injectable({
  providedIn: 'root'
})
export class ApiHelperService {
  storage: Storage;
  userName: string;
  constructor(
    public http: HttpClient,
    private alertService: AlertService,
    private apiGateway: ApiGatewayService,
    injector: Injector
  ) {
    this.storage = injector.get(Storage);
      }

  retrieveAllLoanDetail(loanId: number, showErrorAlert: boolean = false): Promise<any> {
    return this.get(`${API_URL.financialDetail}/loan/${loanId}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getLoanAccountsDetails(loanId: number, filter?: string, associations?: string, showErrorAlert: boolean = false): Promise<any> {
    return this.get(`${API_URL.drawdown}/getLoanAccountsDetails/${loanId}?associations=${associations}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getLoanTransactionAccountsDetails(loanId: number, filter?: string, associations?: string, showErrorAlert: boolean = false): Promise<any> {
    return this.get(`${API_URL.drawdown}/getLoanTransactionAccountsDetails/${loanId}`).then(response => response.data).catch(error => {
      this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      return [];
    });
  }

  rejectApplication(payload: any,loanId: number, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.drawdown}/rejectApplication/${loanId}`,payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getEkycDataByLoanId(payload: any,loanId: number, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.drawdown}/getEkycDataByLoanId/${loanId}`,payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getEkycSubmissionData(filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.ekyc}/searchByTypeSubmission?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }
  
  getEkycAcceptanceData(filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.ekyc}/searchByTypeAcceptance?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  searchHirePurchaseLoanDetail(filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.hirePurchaseLoanDetail}/searchHirePurchaseLoanDetail?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  createUploadedDocument(payload: any, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.documentCheckList}`, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  searchUploadedDocument(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.documentCheckList}/search?${req}`);
  }

  deleteDocument(id: number, payload: any) {
    const req = this.toQuery(payload);
    return this.delete(`${API_URL.documentCheckList}/${id}?${req}`);
  }

  // for onboarding draft
  validateCustomer(payload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.onboardingDraft}/validate`, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  validateCustomerForLoan(payload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.drawdown}/validateCustomerForLoan`, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getUserApplicationForm(id: number, loanId: number, showErrorAlert: boolean = false): Promise<any> {
    return this.get(`${API_URL.user}/form/${id}/loanId/${loanId}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  sendNotification(payload: any, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.social}/sendNotification`, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getLegalAgreement(payload: any, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.drawdown}/legalAgreement `, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  createCtosRequest(payload: any, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.ctos}/request `, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  searchPortfolioCommandSource(filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.portfolioCommandSource}/search?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  loanActionDrawdown(payload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.drawdown}/loan/action `, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  updateDDAUrlStatus(payload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.ringgitPay}/updateDDAUrlStatus`, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getDDAUrlStatus(jwtToken: string, showErrorAlert: boolean = false): Promise<any> {
    return this.get(`${API_URL.ringgitPay}/getDDAUrlStatus/${jwtToken}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getCurrentPenaltyCharges(loanId: number, filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.drawdown}/penalty/loan/${loanId}?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  apiErrorHandler(errorCode: string, errorMessage: string, showAlert: boolean = true): string {
    if (showAlert) {
      this.alertService.presentErrorAlert(errorMessage);
    }
    return `${errorMessage}`;
  }

  toQuery(obj: any): string {
    return Object.keys(obj)
      .map(k => `${k}=${encodeURIComponent(obj[k])}`)
      .join('&');
  }

  private async get(url: string, params?: any, headers?: any): Promise<any> {
  // original web-based logic
  return new Promise((resolve, reject) => {
    this.http.get(url, params).subscribe(
      data => resolve(data),
      err => {
        console.log('GET: Error: ', err);
        reject(err);
      }
    );
  });
}

  async searchAgentList(filter: any): Promise<any> {
    const apiUrl = await this.storage.get('API_URL') || '';
    const agentListJSON = this.toQuery(filter);
    const API_URL = {
      search: { path: `${apiUrl}${environment.apiUrl.apiPath.agentList}/search?${agentListJSON}`, apiName: environment.apiUrl.name },
    };
    // tslint:disable-next-line: no-shadowed-variable
    const request: APIGatewayInitRequest = {
      queryStringParameters: {}
    };
    return await this.apiGateway.get(API_URL.search, request);
  }

  createUser(userJSON): Promise<any> {
    console.log(userJSON);
    return this.post(`${API_URL.user+'/createUserSignUp'}`, userJSON);
  }

  signoutUser(logoutStatus): Promise<any> {
    console.log(logoutStatus);
    return this.post(`${API_URL.auth+'/logout'}`, logoutStatus);
  }

  async createUser1(userJSON) {
    console.log('888');
    const apiUrl = await this.storage.get('API_URL') || '';
    console.log(apiUrl);
    const API_URL = {
      create: { path: `${apiUrl}${environment.apiUrl.apiPath.userProfiles}`, apiName: environment.apiUrl.name },
    };
    // tslint:disable-next-line: no-shadowed-variable
    const request: APIGatewayInitRequest = {
      body: userJSON
    };
    console.log('999' + API_URL);
    return await this.apiGateway.post(API_URL.create, request);
    console.log('000');
  }

  private async post(url: string, body?: any, headers?: any): Promise<any> {
  console.log(url, body, headers);

  // original web-based logic
  return new Promise((resolve, reject) => {
    this.http.post(url, body, headers).subscribe(
      data => resolve(data),
      err => {
        console.log('POST: Error: ', err);
        reject(err);
      }
    );
  });
  }

  public async approveUser(userJSON) {
    const apiUrl = await this.storage.get('API_URL') || '';
    const API_URL = {
      approve: { path: `${apiUrl}${environment.apiUrl.apiPath.userProfiles}/approve`, apiName: environment.apiUrl.name },
    };
    // tslint:disable-next-line: no-shadowed-variable
    const request: APIGatewayInitRequest = {
      body: userJSON
    };
    return await this.apiGateway.post(API_URL.approve, request);
  }

  private async put(url: string, body?: any, headers?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line arrow-body-style
      this.http.put(url, body, headers).subscribe(data => {
        return resolve(data);
      },
        err => {
          console.log('PUT: Error: ', err);
          return reject(err);
        });
    });
  }

  private async delete(url: string, body?: any) {
    return new Promise((resolve, reject) => {
      const options = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body
      };
      console.log('delete options >> ', options);
      // eslint-disable-next-line arrow-body-style
      const subscriber = this.http.delete(url, options).subscribe(data => {
        return resolve(data);
      },
        err => {
          console.log('DELETE: Error: ', err);
          return reject(err);
        });
    });
  }

  searchEmergencyContact(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.emergencyContact}/searchContact?${req}`);
  }

  createEmergencyContact(request: any): Promise<any> {
    return this.post(`${API_URL.emergencyContact}`, request);
  }

  createHirePurchaseDetail(request): Promise<any> {
    return this.post(`${API_URL.hirePurchaseDetail}`, request);
  }

  createFinancialDetail(request): Promise<any> {
    return this.post(`${API_URL.financialDetail}`, request);
  }

  createCurrentEmploymentDetail(request): Promise<any> {
    return this.post(`${API_URL.currentEmploymentDetail}`, request);
  }

  createPastEmploymentDetail(request): Promise<any> {
    return this.post(`${API_URL.pastEmploymentDetail}`, request);
  }

  searchCode(filter) {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.code}/search?${req}`);
  }

  retrievedAgentList(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.agentList}/search?${req}`);
  }

  retrievedAgentAccStatus(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.agentList}/searchAccStatus?${req}`);
  }

  updateAgentData(id: number, payload: any): Promise<any> {
    const url = `${API_URL.agentList}/updateAgentData/${id}`;
    return this.http.put(url, payload).toPromise();
  }

  createClientDefault(requestPayload: Request): Promise<any> {
    return this.post(`${API_URL.clientDefault}/create`, requestPayload);
  }
  createClientAddress(requestPayload: Request): Promise<any> {
    return this.post(`${API_URL.clientAddress}/`, requestPayload);
  }

  retrieveClientDefaultList(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.clientDefault}/search?${req}`);
  }

  updateClientDefault(id: number, payload: any): Promise<any> {
    const url = `${API_URL.clientDefault}/${id}`;
    return this.http.put(url, payload).toPromise()
  }

  updateDrawDowns(payload: any = {}, username: any, id: number,): Promise<any> {
    const url = `${API_URL.drawdown}/updateDrawDowns/${id}`;
    payload.username = username;
    return this.http.put(url, payload).toPromise()
  }

  updateMloan(payload: any = {}, username: any, id: number,): Promise<any> {
    const url = `${API_URL.drawdown}/${id}`;
    payload.username = username;
    return this.http.put(url, payload).toPromise()
  }

  retrieveClientListing(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.user}/search?${req}`);
  }

  retrieveClientAccStatus(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.user}/searchAccStatus?${req}`);
  }

  updateUser(id: number, payload: any): Promise<any> {
    const url = `${API_URL.user}/${id}`;
    return this.http.put(url, payload).toPromise()
  }

  updateLoginAttempt( payload: any): Promise<any> {
    const url = `${API_URL.user}/updateLoginAttempt`;
    return this.http.put(url, payload).toPromise()
  }

  retrieveClientListingWithLoanDetail(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.user}/searchWithLoanDetail?${req}`);
  }

  retrieveApplicationForm(clientId: number, loanId: number): Promise<any> {
    return this.get(`${API_URL.user}/getApplicationById/${clientId}/loanId/${loanId}`);
  }

  retrieveClientAddress(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.clientAddress}/search?${req}`);
  }

  retrieveClientLoanDetails(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.loanClient}/search?${req}`);
  }

  updateClientAddress(clientId: number, payload: any): Promise<any> {
    const url = `${API_URL.clientAddress}/${clientId}`;
    return this.http.put(url, payload).toPromise();
  }

  retriveCodeListByCodeName(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.code}/searchCodeListByCodeName?${req}`);
  }

  searchProductLoan(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.productLoan}/search?${req}`);
  }

  searchProductLoanInfo(loanProductId: number | string, filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.productLoan}/getLoanProductInfo/${encodeURIComponent(loanProductId)}?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getLoanProductAttachmentConfigInfo(attachmentConfigId: number, filter: Request, showErrorAlert: boolean = false): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.productLoan}/getLoanProductAttachmentConfig/${attachmentConfigId}?${req}`).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  searchHirePurcaseProduct(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.hirePurchaseProduct}/search?${req}`);
  }

  searchAddressCountryStatePostcode(requestPayload: Request): Promise<any> {
    const req = this.toQuery(requestPayload);
    return this.get(`${API_URL.address}/countryStatePostcode?${req}`);
  }

  createOnboardingDraft(requestPayload: Request): Promise<any> {
    return this.post(`${API_URL.onboardingDraft}/upsert`, requestPayload);
  }

  retrieveGuarantorListing(requestPayload: Request): Promise<any> {
    const req = this.toQuery(requestPayload);
    return this.get(`${API_URL.guarantor}/retrieve?${req}`);
  }

  upsertOnboardingDraft(payload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.onboardingDraft}/upsert`, payload).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  searchOnboardingDraft(requestPayload: Request): Promise<any> {
    const req = this.toQuery(requestPayload);
    return this.get(`${API_URL.onboardingDraft}/search?${req}`);
  }

  updateOnboardingDraft(userId: number, payload: any): Promise<any> {
    const url = `${API_URL.onboardingDraft}/${userId}`;
    return this.http.put(url, payload).toPromise()
  }

  cancelAndReinstateOnboardingDraft(id, payload) {
    let req = this.toQuery(payload);
    return this.post(`${API_URL.onboardingDraft}/cancelAndReinstate/${id}?${req}`);
  }

  deleteOnboardingDraft(id, payload) {
    let req = this.toQuery(payload);
    return this.delete(`${API_URL.onboardingDraft}/${id}?${req}`);
  }

  searchCurrentEmploymentDetail(requestPayload: Request): Promise<any> {
    const req = this.toQuery(requestPayload);
    return this.get(`${API_URL.currentEmploymentDetail}/searchCurrentEmploymentDetail?${req}`);
  }

  searchPastEmploymentDetail(requestPayload: Request): Promise<any> {
    const req = this.toQuery(requestPayload);
    return this.get(`${API_URL.pastEmploymentDetail}/searchPastEmploymentDetail?${req}`);
  }

  retrieveGuarantorFinancialDetail(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.guarantorFinancialDetail}/search?${req}`);
  }

  retrieveMLoanDetails(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.drawdown}/search?${req}`);
  }
  retrieveFinancialDetail(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.financialDetail}/searchFinancialDetail?${req}`);
  }

  createAndUpdateGuarantorConsent(payload: Request): Promise<any> {
    return this.post(`${API_URL.guarantorConsent}/`, payload);
  }

  getMikrokreditUserProfile(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.mikrokreditUserProfile}/search?${req}`);
  }

  getMikrokreditLoan(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.mikrokreditLoan}/search?${req}`);
  }

  getAmbankStatus(loanId: number): Promise<any> {
    return this.get(`${API_URL.ambankstatus}/searchById/getAmbankStatusByLoanId/${loanId}`);
  }

  //TODO create siteVisit
  createSiteVisit(requestPayload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.siteVisit}/create`, requestPayload).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  createAutoDebitAcceptanceHistory(requestPayload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.autoDebitAcceptance}/create`, requestPayload).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  createClientSupport(requestPayload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.clientSupport}/createClientSupport`, requestPayload).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  retrieveAutoDebitAcceptanceHistory(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.autoDebitAcceptance}/search?${req}`);
  }

  consentReg(requestPayload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.consentReg}`, requestPayload).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
      });
    }

  checkVersion(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.appVersion}/search?${req}`);
  }

  createPortfolioCommandSource(Payload: Request): Promise<any> {
    return this.post(`${API_URL.portfolioCommandSource}/savePortfolioCommandSource`, Payload);
  }

  getOffice(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.office}/searchbyidname?${req}`);
  }

  getOfficeDetails(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    console.log("filter",filter);
    console.log("req", req);
    return this.get(`${API_URL.office}/searchbyStaffid?${req}`);
  }

  getToken(request): Promise<any> {
    return this.post(`${API_URL.auth}/token`, request);
  }

  getGlobalConfiguration(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.globalConfiguration}/search?${req}`);
  }

  getAppSettings(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.appSettings}?${req}`);
  }

  verifyDevice(integrityToken?: string, deviceCode?: string, type: string = 'ANDROID'): Promise<any> {
    return this.post(`${API_URL.playIntegrity}/verify`, {
      integrityToken,
      deviceCode,
      type
    });
  }

  getEarlySettlement(filter: Request): Promise<any> {
    const req = this.toQuery(filter);
    return this.get(`${API_URL.earlySettlement}/search?${req}`);
  }

  createEarlySettlement(requestPayload: Request, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.earlySettlement}/create`, requestPayload).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }

  getEarlySettlementAmount(filter: any): Promise<any> {
    const query = this.toQuery(filter);
    const id = filter?.where?.loanId;

    return this.put(`${API_URL.earlySettlement}/getAmount/${id}?${query}`, {});
  }

  createCognitoUser(userJSON): Promise<any> {
    console.log(userJSON);
    return this.post(`${API_URL.user+'/createUserCognito'}`, userJSON);
  }

  verifyRecaptcha(captchaToken: string, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.recaptcha}/verifyToken`, { captchaToken })
      .catch(error => {
        const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
        throw new Error(errorMessage);
      });
  }

    createUploadedDocumentEkycSubm(payload: any, showErrorAlert: boolean = false): Promise<any> {
    return this.post(`${API_URL.documentCheckList}/createDocEkycSubm`, payload).then(response => response.data).catch(error => {
      const errorMessage = this.apiErrorHandler(error.error.errorCode, error.error.errorMessage, showErrorAlert);
      throw new Error(errorMessage);
    });
  }
   ConfirmAndCreateUser(userJSON): Promise<any> {
    console.log(userJSON);
    return this.post(`${API_URL.user+'/confirmAndcreateUser'}`, userJSON);
  }
}


export interface Request {
  referenceNumber: string;
  channelId: string;
  username: string | Promise<string>;
  filter?: string;
  payload?: {};
}
